/**
 * VRBaseComponent - common VR behavior hooks (e.g., hover) for actor components.
 */

import { SceneComponent } from '../../components/SceneComponent.js';
import { EngineClass } from '../../systems/ClassRegistry.js';

import type { SceneComponentOptions } from '../../components/SceneComponent.js';
import type * as THREE from 'three';

export interface VRBaseComponentOptions extends SceneComponentOptions {}

@EngineClass('VRBaseComponent')
export class VRBaseComponent extends SceneComponent {



  // Default no-op implementations; override in subclasses as needed
  public onVRHoverStart?(hand: 'left' | 'right', point: THREE.Vector3): void;
  public onVRHover?(hand: 'left' | 'right', point: THREE.Vector3): void;
  public onVRHoverEnd?(hand: 'left' | 'right'): void;

  public override getEditorClassIcon(): string | null {
    return 'Icon_Vr';
  }
}


